import NamedResource from "./namedResource";
import {SensitiveValue} from "./propertyValueResource";

export enum CommunicationStyle {
    None = "None",
    TentaclePassive = "TentaclePassive",
    TentacleActive = "TentacleActive",
    Ssh = "Ssh",
    OfflineDrop = "OfflineDrop",
    AzureWebApp = "AzureWebApp",
    Ftp = "Ftp",
    AzureCloudService = "AzureCloudService",
}

// Emulating a resource so we can refer to this enum in dropdownlists easily etc.
export interface CommunicationStyleResource {
    Id: CommunicationStyle;
    Name: string;
}

export interface TentacleDetailsResource {
    UpgradeLocked: boolean;
    Version: string;
    UpgradeSuggested: boolean;
    UpgradeRequired: boolean;
}

export abstract class EndpointResource extends NamedResource {
    CommunicationStyle: CommunicationStyle;
}

export abstract class TentacleEndpointResource extends EndpointResource {
    Thumbprint: string;
    TentacleVersionDetails: TentacleDetailsResource;
    CertificateSignatureAlgorithm: string;
}

export class ListeningTentacleEndpointResource extends TentacleEndpointResource {
    Uri: string;
    ProxyId: string;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.TentaclePassive;
    }
}

export class PollingTentacleEndpointResource extends TentacleEndpointResource {
    Uri: string;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.TentacleActive;
    }
}

// tslint:disable-next-line:no-empty-interface
export abstract class AgentlessEndpointResource extends EndpointResource {
}

export class AzureWebAppEndpointResource extends AgentlessEndpointResource {
    AccountId: string;
    WebSpaceName: string;
    WebAppName: string;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.AzureWebApp;
    }
}

export class CloudRegionEndpointResource extends AgentlessEndpointResource {
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.None;
    }
}

export class CloudServiceEndpointResource extends AgentlessEndpointResource {
    AccountId: string;
    CloudServiceName: string;
    StorageAccountName: string;
    Slot: string;
    SwapIfPossible: boolean;
    UseCurrentInstanceCount: boolean;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.AzureCloudService;
    }
}

export class OfflineDropEndpointResource extends AgentlessEndpointResource {
    DropFolderPath: string;
    SensitiveVariablesEncryptionPassword: SensitiveValue;
    ApplicationsDirectory: string;
    OctopusWorkingDirectory: string;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.OfflineDrop;
    }
}

export class SshEndpointResource extends AgentlessEndpointResource {
    AccountId: string;
    Host: string;
    Port: number;
    Fingerprint: string;
    Uri: string;
    ProxyId: string;
    DotNetCorePlatform: string;
    constructor() {
        super();
        this.CommunicationStyle = CommunicationStyle.Ssh;
    }
}

export default EndpointResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/endpointResource.ts